import type { LanguageLocalesEnum, SlideTranslatedText, SupportedLanguages } from 'js/src/client';
import type { SelectOption } from 'js/src/components/common/ui/Select/types';
import type { DeepReadonly } from 'js/src/libs/consts';

export const TRANSLATIONS_ACTIONS = {
    STORE_TRANSLATIONS: 'STORE_TRANSLATIONS',
    STORE_SUPPORTED_LANGUAGES: 'STORE_SUPPORTED_LANGUAGES',
};

export type TranslationSelectValue = SelectOption<LanguageLocalesEnum>;

export type ReadonlySupportedLanguage = DeepReadonly<SupportedLanguages>;
export type ReadonlySlideTranslatedText = DeepReadonly<SlideTranslatedText>;
